<template>
  <div class="search-container">
    <div class="main-width">
      <el-input class="search-input" ref="searchInput" placeholder="请输入搜索内容" v-model="searchInfo" clearable @keyup.enter.native="searchData">
        <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
      </el-input>
      <div v-if="searchList.length" v-loading="loading">
        <div class="search-list">
          <div class="search-item" v-for="(item, index) in searchList" :key="index">
            <SearchItem :info="item"></SearchItem>
          </div>
        </div>
        <!-- 分页 -->
        <pagination v-show="total>0" :total="total" :page.sync="pageParams.pageNumber" :limit.sync="pageParams.pageSize" @pagination="getData" />
      </div>
      <div class="none-result" v-else>
        暂无搜索结果
      </div>
    </div>
  </div>
</template>

<script>
import { contentFinds } from "@/api/common/content";

import SearchItem from "./components/searchItem";
export default {
  data() {
    return {
      queryBean: {
        contentBean: {
          name: "",
        },
      },
      pageParams: {
        pageNumber: 1,
        pageSize: 10,
        sort: "priority, publish_time",
        order: "desc"
      },
      total: 0,
      searchList: [],
      searchInfo: "",
      loading: true
    }
  },
  props: {

  },
  components: {
    SearchItem
  },
  mounted() {
    this.initRouter();
  },
  methods: {
    initRouter() {
      let { search } = this.$route.query;
      if (search) {
        this.searchInfo = search;
        this.queryBean.contentBean.name = this.searchInfo;
        this.getData();
      }
    },
    searchData() {
      this.$router.push({
        path: "/redirect/views/search",
        [this.searchInfo ? 'query' : '']: {
          search: this.searchInfo
        }
      })
    },
    // 请求数据
    async getData(params) {
      this.loading = true;
      let data = Object.assign({}, this.pageParams, this.queryBean, params || {});
      const res = await contentFinds(data);
      this.loading = false;
      if (res.status == 200) {
        this.searchList = res.data.list;
        this.total = res.data.total;
      }
    }
  },
}
</script>

<style lang="less" scoped>
.search-container {
  .search-input {
    border: 1px solid rgba(103, 109, 114, 0.6);
    margin-bottom: 20px;
    /deep/ .el-input__inner {
      color: #333;
      border: none;
    }
    /deep/ .el-input-group__append,
    .el-input-group__prepend {
      background-color: transparent;
      border: none;
      .el-button {
        margin: 0;
      }
      .el-icon-search {
        font-size: 18px;
      }
    }
  }
  .none-result {
    text-align: center;
    font-size: 16px;
    color: #999;
    line-height: 60px;
    margin: 30px;
  }
}
</style>